(function () {
	'use strict';
	$(document).ready(function () {

	    // responsive-image module zoomable feature
	    document.querySelectorAll('.module.responsive-image .image-container.zoomable .desktop-image').forEach((containerElement) => {
		    const popupContainer = document.createElement('div');
		    popupContainer.classList.add('popup-image-container');
		    const clonedImg = containerElement.parentElement.querySelector('.popup-image img').cloneNode(true);
		    clonedImg.classList.add('popup-image');
		    popupContainer.appendChild(clonedImg);

		    const removePopupContainer = () => {
			    $(popupContainer).fadeOut(() => {
				    popupContainer.remove();
			    });
		    };
		    popupContainer.addEventListener('click', removePopupContainer);

		    const mediaQuery = window.matchMedia('(min-width: 768px)');
		    mediaQuery.addEventListener('change', () => {
			    if (!mediaQuery.matches) {
				    removePopupContainer();
			    }
		    })
		    containerElement.querySelector('img').addEventListener('click', () => {
			    if (mediaQuery.matches) {
				    document.body.appendChild(popupContainer);
				    $(popupContainer).fadeIn();
			    }
		    })
	    });

		//Video module

		document.querySelectorAll('.video .play-button').forEach(function (videoButton) {
			const video = videoButton.closest('.video-wrapper').querySelector('video');
			video.addEventListener('playing', videoPausePlayHandler, false);
			video.addEventListener('pause', videoPausePlayHandler, false);

			function videoPausePlayHandler(e) {
				if (e.type === 'playing') {
					videoButton.style.display = 'none';
					video.setAttribute("controls","controls");
				} else if (e.type === 'pause') {
					videoButton.style.display = 'flex';
					video.removeAttribute("controls");
				}
			}

			videoButton.addEventListener('click', function (e) {
				video.play();
			})
		});

        //Tooltipster

		// default tooltips
		$('.default-tooltipster').tooltipster({
			maxWidth: 290,
			contentAsHTML: true,
			interactive: true,
			functionPosition: function (instance, helper, position) {
				position.coord.left = helper.geo.origin.offset.left - 20;
				return position;
			},
		});

		document.querySelectorAll('section.pages-list .swiper, section.posts-list .swiper').forEach(function (swiperEl) {
			new Swiper(swiperEl, {
				autoHeight: true,
				effect: 'fade',
				fadeEffect: {
					crossFade: true
				},
				pagination: {
					el: '.swiper-pagination',
					clickable: true,
					renderBullet: function (index, className) {
						return '<span class="' + className + '">' + (index + 1) + "</span>";
					}
				},
				navigation: {
					nextEl: '.swiper-navigation .swiper-button-next',
					prevEl: '.swiper-navigation .swiper-button-prev',
				},
			});
		});

		document.querySelectorAll('section.posts-list .show-more').forEach(function (button) {
			button.addEventListener('click', function (){
				$(button).siblings('.posts-list-container').children('.hidden-group').each(function (index) {
					setTimeout(() => {
						$(this).slideToggle();
					}, index * 400)
				});
			})
		});
	});
}(jQuery));
